<script>
    import {createEventDispatcher} from 'svelte';

    export let reverse = false;

    let order;
    let ascClassActive = false;
    let descClassActive = false;

    $: ascClassActive = handleActiveClass(order, 'ascending');
    $: descClassActive = handleActiveClass(order, 'descending');

    const dispatch = createEventDispatcher();


    function onSortUp(){
        if(!order){
            order = 'ascending';

            if(reverse){
                order = 'descending';
            }
        } else {
            if(reverse){
                if(order === 'ascending'){
                    order = 'descending';
                } else {
                    order = null;
                }
            } else {
                if(order === 'descending'){
                    order = 'ascending';
                } else {
                    order = null;
                }
            }
        }

        dispatch('sort', {
            direction: order
        })
    }

    function onSortDown(){
        if(!order){
            order = 'descending';

            if(reverse){
                order = 'ascending';
            }
        } else {
            if(reverse){
                if(order === 'descending'){
                    order = 'ascending';
                } else {
                    order = null;
                }
            } else {
                if(order === 'ascending'){
                    order = 'descending';
                } else {
                    order = null;
                }
            }
        }
        dispatch('sort', {
            direction: order
        })
    }

    function handleActiveClass(order, direction){
        if(order){
            return reverse ? !(order === direction) : order === direction;
        }
        return false;
    }
</script>

<style>
    .wrapper {
        display: flex;
        flex-direction: column;
    }

    i {
        height: 10px;
        cursor: pointer;
    }

    i:hover {
        color: #f77f00;
    }

</style>

<div class="wrapper">
    <i class:text-bhp-orange-1={ascClassActive} class="fas fa-sort-up" on:click={onSortUp}></i>
    <i class:text-bhp-orange-1={descClassActive} class="fas fa-sort-down" on:click={onSortDown}></i>
</div>
